import * as API from "../framework/api";
import Alpine from "alpinejs";

document.addEventListener("click", async function (event) {
  if (event.target && event.target.matches(".js-save-activity")) {
    onSaveItem(event.target);
  }
});

document.addEventListener("alpine:init", () => {
  createActivitiesUpdatesStore();
  createActivitySelectionStore();
});

async function onSaveItem(buttonEl) {
  const activity = buttonEl.closest(".js-activity-container");
  const activityId = activity.dataset.activityId;
  const resourceId = activity.dataset.resourceId;
  const resourceType = activity.dataset.resourceType;
  const errorToastId = activity.dataset.errorToastId;

  const form = buttonEl.closest(".js-activity-container__form");
  const name = form.querySelector(".activity-name")?.value ?? undefined;
  const description = form.querySelector(".activity-description")?.value ?? undefined;
  const duration = form.querySelector(".activity-duration")?.value ?? undefined;
  const durationUE = form.querySelector(".activity-duration-ue")?.value ?? undefined;
  const submitButton = form.querySelector(".js-save-activity");

  const data = {
    name: name,
    description: description,
    duration_min: duration,
    duration_ue: durationUE,
    resource_type: resourceType,
    resource_id: resourceId,
  };

  if (resourceType === "html_doc") {
    const replayable = form.querySelector(".activity-replayable")?.checked ?? undefined;
    const show_score = form.querySelector(".activity-show-score")?.checked ?? undefined;
    const show_validation = form.querySelector(".activity-show-validation")?.checked ?? undefined;

    data.resource = {
      id: resourceId,
    };

    if (show_validation !== undefined) data.resource.show_validation = show_validation;
    if (replayable !== undefined) data.resource.replayable = replayable;
    if (show_score !== undefined) data.resource.show_score = show_score;
  }

  let hasSavedSuccessfully = true;
  try {
    const result = await API.fetchJSON(p`/ajax/activities/${activityId}`, {
      method: "PUT",
      body: data,
    });

    hasSavedSuccessfully = result.success;
  } catch (_error) {
    hasSavedSuccessfully = false;
  }

  if (hasSavedSuccessfully) {
    // change button text to data saved !
    submitButton.innerText = submitButton.dataset.saved;
    submitButton.classList.add("js-save-item-clicked");
    // save all updates to store, then new data is not lost when we click on another module and go back to this one without reloading the page.
    saveActivitiesUpdatesToStore(activityId, data);

    // change button text to save data
    const SUCCESS_MESSAGE_DURATION_MS = 3000;

    setTimeout(() => {
      submitButton.innerText = submitButton.dataset.custom;
      submitButton.classList.remove("js-save-item-clicked");
    }, SUCCESS_MESSAGE_DURATION_MS);
  } else {
    window.toast.show("#" + errorToastId);
  }
}

function createActivitiesUpdatesStore() {
  // this store is created to save activities updates so that components use this as the first source of data,
  // then fall back to the values contained in the HTML.
  Alpine.store("activityUpdates", {});
}

function createActivitySelectionStore() {
  Alpine.store("activitySelection", {
    nbrMaxActivity: 0,
    activitiesIdsSelected: [],

    init(maxActivity) {
      this.nbrMaxActivity = maxActivity;
      this.activitiesIdsSelected = [];
    },

    canSelect(activityId) {
      return this.nbrMaxActivity > 0 || this.activitiesIdsSelected.includes(activityId);
    },
  });
}

function saveActivitiesUpdatesToStore(activityId, data) {
  Alpine.store("activityUpdates")[activityId] = data;
}
